var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view__login"},[_c('div',{staticClass:"view__login-content"},[_c('img',{attrs:{"src":_vm.logo.src,"alt":"Trunk CMS","width":_vm.logo.width,"height":_vm.logo.height}}),_vm._v(" "),_c('login-form',{on:{"loginSuccess":_vm.loginSuccess,"loginFail":_vm.loginFail,"resetSuccess":_vm.resetSuccess,"resetFail":_vm.resetFail}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15d1b5a8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 355
// module chunks = 8